import { addReducer } from '../Store';
import { IdentitySession } from './reducers';

const injectReducers = (): void => {
  addReducer('IdentitySession', IdentitySession);
};

injectReducers();

if (module.hot) {
  module.hot.accept('./reducers', injectReducers);
}
